import React from 'react';
import { useLocation } from 'react-router';
import clsx from 'clsx';
import { Skeleton } from '../Skeletons';
import { Link } from 'react-router';

export interface NavTab {
  title: string;
  href: string;
}

export interface TabNavProps {
  tabs: (NavTab | null)[];
  children?: React.ReactNode;
  loading?: boolean;
}

export const TabNav = ({ tabs, children, loading }: TabNavProps) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <>
      {loading ? (
        <Skeleton height="2rem" />
      ) : (
        <nav className="overflow-x-scroll relative mb-14 no-scrollbar max-w-[1400px]">
          <ul className="flex gap-y-1 w-min border-b-2 sm:flex-wrap sm:w-full dark:border-blue-900 border-grey-400">
            {tabs.map((tab: NavTab | null, i: number) => {
              if (!tab) return;

              const selected = path === tab.href;

              return (
                <li
                  key={tab.title + i}
                  className={clsx(
                    ' -mb-0.5 flex justify-center rounded-b-none rounded-t-md cursor-pointer transition-colors text-grey-1000 mr-0 min-w-[150px] sm:min-w-[200px] whitespace-nowrap relative z-10',
                    'hover:!bg-blue-200 hover:!border-blue-800 dark:hover:!bg-blue-900 dark:hover:!border-blue-800 text-sm',
                    selected
                      ? 'bg-transparent !border-blue-800 font-bold dark:text-blue-400 text-blue-800'
                      : 'border-transparent text-grey-500 dark:text-grey-400 dark:border-transparent'
                  )}
                >
                  <Link
                    to={tab.href}
                    key={tab.href}
                    className={clsx(
                      'w-full text-center whitespace-nowrap px-2 py-1.5 block hover:border-b-2 hover:border-blue-800',
                      selected
                        ? 'bg-transparent !border-blue-800 border-b-2 font-bold dark:text-blue-400 text-blue-800'
                        : 'border-transparent  dark:border-transparent'
                    )}
                  >
                    {tab.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      )}
      {children}
    </>
  );
};
